import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { formatGel } from '../lib/format';
import { useI18n } from '../lib/i18n';

interface Preview { cashbackTetri: number; points: number; lifetimeSpendTetri: number }

const signed = (value: number, text: string) => (value > 0 ? `+${text}` : value < 0 ? `−${text}` : text);

/** What the customer's balances do if the order goes; nothing shown when they do not move. */
export function OrderEraseEffects({ orderId, open }: { orderId: string; open: boolean }) {
  const { t } = useI18n();
  const { data } = useQuery({
    queryKey: ['erase-preview', orderId],
    enabled: open,
    queryFn: () => api<Preview>(`/admin/orders/${orderId}/erase-preview`),
  });
  if (!data) return null;
  const rows = [
    [t('erase.cashback'), data.cashbackTetri, signed(data.cashbackTetri, formatGel(Math.abs(data.cashbackTetri)))],
    [t('erase.points'), data.points, signed(data.points, String(Math.abs(data.points)))],
    [t('erase.spend'), data.lifetimeSpendTetri, signed(data.lifetimeSpendTetri, formatGel(Math.abs(data.lifetimeSpendTetri)))],
  ] as const;
  const moving = rows.filter(([, value]) => value !== 0);
  if (moving.length === 0) return null;
  return (
    <dl className="space-y-1 rounded-xl border border-line bg-raised/60 p-3 text-sm">
      {moving.map(([label, , text]) => (
        <div key={label} className="flex justify-between gap-3">
          <dt className="text-ink-dim">{label}</dt>
          <dd className="tabular font-semibold text-ink">{text}</dd>
        </div>
      ))}
    </dl>
  );
}
